import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, Quote } from 'lucide-react';
export const ProjectsVendorsPage = () => {
  const partners = [{
    name: 'CUES',
    logo: 'https://cdn.magicpatterns.com/uploads/wNdbJbJUA819KtS1bD1EiV/logo-cue.png',
    description: 'Leading manufacturer of CCTV inspection equipment and software.'
  }, {
    name: 'FerraTex Solutions',
    logo: 'https://cdn.magicpatterns.com/uploads/9nzMmURpvoQyQzG4wYPmPc/Screenshot_2026-02-02_at_4.50.38_PM.png',
    description: 'Premier provider of CIPP liners and wet-out services.'
  }, {
    name: 'Nozzteq - A Division of Enz',
    logo: 'https://cdn.magicpatterns.com/uploads/jmfdCUy3pkfotycRrRjuse/660f0f7387eef0923df1a698_NozzTeq_Logo_High_res_1920x1080_transparent_1.png',
    description: 'High-performance cleaning nozzles and cutters.'
  }, {
    name: 'Pittsburgh Wire & Cable Inc.',
    logo: 'https://cdn.magicpatterns.com/uploads/ogxkVTotoXV8v2PS1JQQp6/pittsburgh_wire_cable_inc_logo.jpg',
    description: 'Specialized wire and cable solutions for industrial use.'
  }, {
    name: 'Vactor',
    logo: 'https://cdn.magicpatterns.com/uploads/kKUcN6DD2K1rVjSdET6Unc/Vactor-logo.jpg',
    description: 'Industry leader in sewer cleaners and catch basin cleaners.'
  }, {
    name: 'Puris',
    logo: 'https://cdn.magicpatterns.com/uploads/r6KmtQzDwW6XmWWFGWiuQh/Puris_Logo_CLR.jpg',
    description: 'Trenchless pipe rehabilitation solutions.'
  }];
  const projects = [{
    title: 'Municipal Manhole Rehabilitation',
    location: 'Knoxville, TN',
    description: 'Rehabilitation of 50+ deteriorating brick manholes using cementitious lining to stop infiltration and restore structural integrity.',
    beforeImage: 'https://cdn.magicpatterns.com/uploads/1C2NBu3NsJVBKxWppqsWSH/pipesvcbefore.jpg',
    afterImage: 'https://cdn.magicpatterns.com/uploads/vzBEi6rojirjPEtvLL2MEv/pipesvcafter.jpg'
  }, {
    title: 'Storm Drain Cleaning Project',
    location: 'Oak Ridge, TN',
    description: 'Large-scale cleaning of storm drain infrastructure for a commercial complex to prevent flooding during heavy rains.',
    image: 'https://cdn.magicpatterns.com/uploads/dkVKxXDJPMH6qP2vnxgkwZ/image-5.jpg'
  }, {
    title: 'Hydro Excavation Service',
    location: 'Maryville, TN',
    description: 'Precision hydro excavation to safely expose underground utilities. Our specialized equipment uses high-pressure water and vacuum to excavate without damaging existing infrastructure.',
    image: 'https://cdn.magicpatterns.com/uploads/6rUVxhTqiXqsRCqdA2GT9A/Screenshot_2026-02-03_at_2.34.58_PM.png'
  }];
  const testimonials = [{
    quote: 'During the past few years, our company has been working with M&M Pipe Services on numerous projects. This company offers high-quality services, and we have always been satisfied with their work. They are courteous, punctual, and offer the most competitive prices around. They clean storm lines, sewer lines, provide video for lines and put on flash drives. We strongly recommend them for all your storm/sewer needs. We look forward to working with them in the future.',
    author: 'Clark Enterprises',
    location: 'Knoxville, TN',
    type: 'Commercial'
  }, {
    quote: 'I can highly recommend M&M Pipe Services for any plumbing problems that you may be dealing with, including the most difficult and complicated plumbing malfunctions. They are friendly, thorough, hardworking, and extremely competent, providing overall excellent service. My family and I had a sewage back-up at our home due to the negligent work of a prior contractor. M&M identified the problem and proceeded to remedy it ably and promptly, and at an affordable price! I cannot complement M&M and their people enough. Well done, M&M!',
    author: 'Bradley Williams',
    location: 'Norris, TN',
    type: 'Residential'
  }];
  return <div className="bg-white" data-id="element-266">
      {/* Page Header */}
      <div className="bg-[#1e3a5f] py-20 px-4 text-center relative overflow-hidden" data-id="element-267">
        <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-268"></div>
        <h1 className="text-4xl md:text-5xl font-bold text-white uppercase tracking-wider mb-4 relative z-10" data-id="element-269">
          Projects & Vendors
        </h1>
        <div className="w-24 h-1.5 bg-[#d4a017] mx-auto mb-6 relative z-10" data-id="element-270"></div>
        <p className="text-gray-300 max-w-2xl mx-auto text-lg relative z-10" data-id="element-271">
          We partner with the best in the industry to deliver superior results
          for our clients.
        </p>
      </div>

      {/* Featured Projects */}
      <section className="py-16 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-272">
        <div className="text-center mb-12" data-id="element-273">
          <h2 className="text-3xl font-bold text-[#1e3a5f] mb-4" data-id="element-274">
            Featured Projects
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-275">
            A showcase of our recent work in sewer maintenance, rehabilitation,
            and inspection across East Tennessee.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-12" data-id="element-276">
          {/* Project 1 - Before/After Feature */}
          <div className="bg-gray-50 rounded-xl overflow-hidden shadow-md border border-gray-100" data-id="element-277">
            <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-278">
              <div className="p-8 lg:p-12 flex flex-col justify-center" data-id="element-279">
                <div className="inline-block bg-[#d4a017] text-[#1e3a5f] px-3 py-1 text-xs font-bold uppercase tracking-wider rounded mb-4 w-fit" data-id="element-280">
                  Featured Project
                </div>
                <h3 className="text-2xl font-bold text-[#1e3a5f] mb-2" data-id="element-281">
                  {projects[0].title}
                </h3>
                <p className="text-gray-500 font-medium mb-6 flex items-center" data-id="element-282">
                  <span className="w-2 h-2 bg-[#d4a017] rounded-full mr-2" data-id="element-283"></span>
                  {projects[0].location}
                </p>
                <p className="text-gray-600 leading-relaxed mb-6" data-id="element-284">
                  {projects[0].description}
                </p>
                <div className="flex flex-wrap gap-2" data-id="element-285">
                  <span className="bg-white px-3 py-1 rounded-full text-sm text-gray-600 border border-gray-200" data-id="element-286">
                    Manhole Rehab
                  </span>
                  <span className="bg-white px-3 py-1 rounded-full text-sm text-gray-600 border border-gray-200" data-id="element-287">
                    Structural Repair
                  </span>
                </div>
              </div>
              <div className="grid grid-cols-2 h-64 lg:h-auto" data-id="element-288">
                <div className="relative h-full" data-id="element-289">
                  <img src={projects[0].beforeImage} alt="Before" className="w-full h-full object-cover" data-id="element-290" />
                  <div className="absolute bottom-0 left-0 right-0 bg-black/70 text-white text-center py-1 text-xs font-bold uppercase" data-id="element-291">
                    Before
                  </div>
                </div>
                <div className="relative h-full" data-id="element-292">
                  <img src={projects[0].afterImage} alt="After" className="w-full h-full object-cover" data-id="element-293" />
                  <div className="absolute bottom-0 left-0 right-0 bg-[#d4a017] text-[#1e3a5f] text-center py-1 text-xs font-bold uppercase" data-id="element-294">
                    After
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Other Projects Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-295">
            {projects.slice(1).map((project, index) => <div key={index} className="bg-white rounded-xl overflow-hidden shadow-md border border-gray-100 group hover:shadow-lg transition-shadow" data-id="element-296">
                <div className="h-64 overflow-hidden" data-id="element-297">
                  <img src={project.image} alt={project.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-298" />
                </div>
                <div className="p-8" data-id="element-299">
                  <h3 className="text-xl font-bold text-[#1e3a5f] mb-2" data-id="element-300">
                    {project.title}
                  </h3>
                  <p className="text-gray-500 font-medium mb-4 flex items-center text-sm" data-id="element-301">
                    <span className="w-1.5 h-1.5 bg-[#d4a017] rounded-full mr-2" data-id="element-302"></span>
                    {project.location}
                  </p>
                  <p className="text-gray-600 text-sm leading-relaxed" data-id="element-303">
                    {project.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 bg-[#1e3a5f] relative overflow-hidden" data-id="element-304">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-5" data-id="element-305">
          <div className="absolute inset-0" style={{
          backgroundImage: "url('https://www.transparenttextures.com/patterns/cubes.png')"
        }} data-id="element-306"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-307">
          <div className="text-center mb-16" data-id="element-308">
            <h2 className="text-3xl font-bold text-white mb-4" data-id="element-309">
              What Our Clients Say
            </h2>
            <div className="w-20 h-1.5 bg-[#d4a017] mx-auto" data-id="element-310"></div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-311">
            {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-xl p-8 md:p-10 shadow-xl relative" data-id="element-312">
                {/* Quote Icon */}
                <div className="absolute -top-5 left-8 bg-[#d4a017] w-12 h-12 rounded-full flex items-center justify-center shadow-lg" data-id="element-313">
                  <Quote className="w-6 h-6 text-[#1e3a5f]" data-id="element-314" />
                </div>

                {/* Type Badge */}
                <div className="flex justify-end mb-4" data-id="element-315">
                  <span className="text-xs font-bold uppercase tracking-wider text-[#d4a017] bg-[#d4a017]/10 px-3 py-1 rounded-full" data-id="element-316">
                    {testimonial.type}
                  </span>
                </div>

                {/* Quote Text */}
                <blockquote className="text-gray-600 leading-relaxed mb-8 text-[15px]" data-id="element-317">
                  "{testimonial.quote}"
                </blockquote>

                {/* Author */}
                <div className="border-t border-gray-100 pt-6" data-id="element-318">
                  <p className="font-bold text-[#1e3a5f] text-lg" data-id="element-319">
                    {testimonial.author}
                  </p>
                  <p className="text-gray-500 flex items-center mt-1" data-id="element-320">
                    <span className="w-2 h-2 bg-[#d4a017] rounded-full mr-2" data-id="element-321"></span>
                    {testimonial.location}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Vendors Section */}
      <section className="py-16 bg-gray-50" data-id="element-322">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-323">
          <div className="text-center mb-12" data-id="element-324">
            <h2 className="text-3xl font-bold text-[#1e3a5f] mb-4" data-id="element-325">
              Our Trusted Vendors
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-326">
              We utilize equipment and materials from the industry's most
              respected manufacturers to ensure quality and reliability.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-327">
            {partners.map((partner, index) => <div key={index} className="bg-white p-8 rounded-lg shadow-sm hover:shadow-md transition-shadow flex flex-col items-center text-center border-t-4 border-transparent hover:border-[#d4a017]" data-id="element-328">
                <div className="h-24 flex items-center justify-center mb-6 w-full" data-id="element-329">
                  <img src={partner.logo} alt={partner.name} className="max-h-full max-w-[80%] object-contain" data-id="element-330" />
                </div>
                <h3 className="text-lg font-bold text-[#1e3a5f] mb-2" data-id="element-331">
                  {partner.name}
                </h3>
                <p className="text-sm text-gray-500" data-id="element-332">{partner.description}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Certifications */}
      <section className="py-16 bg-white" data-id="element-333">
        <div className="max-w-7xl mx-auto px-4 text-center" data-id="element-334">
          <h2 className="text-2xl font-bold text-[#1e3a5f] mb-8" data-id="element-335">
            Certified Excellence
          </h2>
          <div className="flex flex-wrap justify-center gap-8 md:gap-16" data-id="element-336">
            <img src="https://cdn.magicpatterns.com/uploads/e3gmq2BP1jL2eiKDfzZ1An/Badge-PACP.png" alt="PACP" className="h-24 object-contain" data-id="element-337" />
            <img src="https://cdn.magicpatterns.com/uploads/hNCCy2K15mUz4yJymjbgMJ/LACP-CERTIFIED.png" alt="LACP" className="h-24 object-contain" data-id="element-338" />
            <img src="https://cdn.magicpatterns.com/uploads/mu2YoBgtQ6GHD7rj93TwzT/MACP-CERTIFIED2.png" alt="MACP" className="h-24 object-contain" data-id="element-339" />
          </div>
        </div>
      </section>
    </div>;
};